module.exports = __webpack_public_path__ + "img/13.be47c53b.png";